module.exports = __webpack_public_path__ + "img/p3_4.b76ef78e.png";